import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import blockchainApi from "../api/blockchainApi";
import PromosApi from "../api/PromosApi";
import TokenIcon from "../components/TokenIcon";
import { setSelectedPromo } from "../store/slices/selectedPromoSlice";
import { setPage } from "../store/slices/pageSlice";

const fmtDate = (d) => {
    try {
        return new Date(d).toLocaleDateString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
        });
    } catch {
        return "";
    }
};

export default function HistoryLayout() {
    const dispatch = useDispatch();
    const [items, setItems] = useState(null); // null — грузим
    const [error, setError] = useState(false);
    const [openingId, setOpeningId] = useState(null);

    useEffect(() => {
        let alive = true;
        blockchainApi
            .getMyHistory()
            .then((res) => { if (alive) setItems(res?.items || []); })
            .catch(() => { if (alive) { setItems([]); setError(true); } });
        return () => { alive = false; };
    }, []);

    // Депозит — всегда своё промо (владельцу — таблица/статистика). Чужое промо
    // из выигрыша — таблица только когда завершено, иначе обычная страница промо.
    const openPromo = async (item) => {
        if (openingId) return;
        setOpeningId(`${item.type}-${item.txHash}`);
        try {
            const promo = await PromosApi.getById(item.promoId);
            if (!promo?.id) return;
            dispatch(setSelectedPromo(promo));
            const isCompleted = promo.status === "COMPLETED" || promo.status === "MANUALLY_COMPLETED";
            if (isCompleted || item.type !== "withdrawal") {
                dispatch(setPage({ id: 8, name: "CompletedPromo" }));
            } else {
                dispatch(setPage({ id: 5, name: "PromoDetails" }));
            }
        } catch {
            // промо могли удалить — молча остаёмся в истории
        } finally {
            setOpeningId(null);
        }
    };

    if (items === null) {
        return (
            <div className="w-full px-[15px] py-4">
                {[0, 1, 2].map((i) => (
                    <div key={i} className="w-full h-[56px] rounded-[10px] bg-white/5 animate-pulse mb-3" />
                ))}
            </div>
        );
    }

    if (!items.length) {
        return (
            <div className="w-full h-full flex items-center justify-center px-[15px] py-4">
                <span className="text-white/40 text-[14px]">
                    {error ? "Failed to load history" : "No transactions yet"}
                </span>
            </div>
        );
    }

    return (
        <div className="w-full h-full flex flex-col px-[15px] py-4">
            <div className="w-full flex-1 overflow-y-auto">
                {items.map((item) => {
                    const isDeposit = item.type === "deposit";
                    const isRefund = item.type === "refund";
                    const token = item.tokenSymbol || "";
                    const rowKey = `${item.type}-${item.txHash}`;
                    const opening = openingId === rowKey;
                    return (
                        <div
                            key={rowKey}
                            className="w-full flex flex-row items-center justify-between py-3 border-b border-white/10"
                        >
                            <div className="flex flex-row items-center gap-3">
                                <div className="w-[32px] h-[32px] rounded-full bg-white/5 flex items-center justify-center">
                                    <TokenIcon symbol={token} address={item.tokenAddress} />
                                </div>
                                <div className="flex flex-col gap-0.5">
                                    <span className="text-[13px] text-white font-semibold">
                                        {isDeposit ? "Deposit" : "Withdraw"} {token}
                                    </span>
                                    <div className="flex flex-row items-center gap-1.5">
                                        <span className="text-[11px] text-[#959595]">
                                            {isDeposit ? "To promo" : isRefund ? "Unspent budget" : "Prize"}
                                        </span>
                                        {item.promoId && (
                                            <button
                                                onClick={() => openPromo(item)}
                                                disabled={Boolean(openingId)}
                                                className={`rounded-[6px] border border-white/15 px-1.5 py-[1px] text-[10px] text-white/60 transition active:bg-white/10 ${opening ? "opacity-50" : ""}`}
                                            >
                                                Promo ›
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-col items-end">
                                <span className="text-[13px] text-white font-semibold">
                                    {isDeposit ? "+" : "-"} {item.amount ?? "—"} {token}
                                </span>
                                <span className="text-[11px] text-[#959595]">
                                    {fmtDate(item.date)}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
